// getPulseLevel.js

function calculateAgeInMonths(birthdate) {
  if (!birthdate) return null;
  const birth = new Date(birthdate);
  const now = new Date();
  const years = now.getFullYear() - birth.getFullYear();
  const months = years * 12 + (now.getMonth() - birth.getMonth());
  return months;
}

export function getPulseLevel(value, speciesId, weight, birthdate) {
  if (speciesId === 1) {
    // Dog
    const ageInMonths = calculateAgeInMonths(birthdate);

    if (ageInMonths !== null && ageInMonths <= 6) {
      // Puppy (≤ 6 months)
      if (value <= 99) return "error";
      if (value >= 100 && value <= 119) return "warning";
      if (value >= 120 && value <= 160) return "success";
      if (value >= 161 && value <= 219) return "warning";
      if (value >= 220) return "error";
    } else if (weight !== null) {
      if (weight < 13.5) {
        // Small dog
        if (value <= 69) return "error";
        if (value >= 70 && value <= 99) return "warning";
        if (value >= 100 && value <= 140) return "success";
        if (value >= 141 && value <= 180) return "warning";
        if (value >= 181) return "error";
      } else {
        // Large dog
        if (value <= 39) return "error";
        if (value >= 40 && value <= 59) return "warning";
        if (value >= 60 && value <= 100) return "success";
        if (value >= 101 && value <= 140) return "warning";
        if (value >= 141) return "error";
      }
    }
  } else if (speciesId === 2) {
    // Cat
    if (value <= 99) return "error";
    if (value >= 100 && value <= 120) return "warning";
    if (value >= 121 && value <= 220) return "success";
    if (value >= 221 && value <= 240) return "warning";
    if (value >= 241) return "error";
  }

  // Default fallback
  return "";
}